import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Reveal, Hairline } from "@/components/primitives";

export default function Foundation() {
  return (
    <div className="min-h-screen bg-[var(--stone)] text-[var(--ink)]" data-testid="foundation-page">
      <Seo title="The Jennae Michelle Foundation" description="Be the light that shows others what they are capable of. The philanthropic arm of the Jennae Michelle Holdings ecosystem, created to help people recognize and develop their own capabilities." />
      <h1 className="sr-only">Jennae Michelle Foundation</h1>

      <section className="pt-28 md:pt-36 pb-2 px-6 text-center">
        <Reveal>
          <img src="/brand/foundation-official.png" alt="Jennae Michelle Foundation" className="mx-auto w-full max-w-xl md:max-w-2xl" />
        </Reveal>
      </section>

      <section className="pb-6 px-6 text-center">
        <Reveal>
          <h2 className="font-display uppercase tracking-wide2 text-xl md:text-3xl leading-snug text-[var(--ink)]">Be the light that shows others<br />what they are capable of.</h2>
        </Reveal>
      </section>

      <section className="pb-6 px-6">
        <div className="max-w-2xl mx-auto"><Reveal><Hairline className="opacity-70" /></Reveal></div>
      </section>

      <section className="py-10 px-6">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <Reveal><h2 className="font-serif2 italic text-2xl md:text-3xl leading-snug text-[var(--ink)]">Light does not give someone ability. It allows her to see what was already there.</h2></Reveal>
          <Reveal delay={0.08}><p className="mt-6 text-lg md:text-xl leading-relaxed text-[var(--ink-muted)]">The Jennae Michelle Foundation is rooted in the belief that support should not make people feel smaller, dependent, or grateful merely to have been noticed. It should help them recognize their own abilities, gain access to experiences that expand what they believe they can do, and carry that knowledge forward as their own.</p></Reveal>
          <Reveal delay={0.14}><p className="text-lg md:text-xl leading-relaxed text-[var(--ink)]">Sometimes the most important thing one person can offer another is not an answer. It is enough light to see the next step.</p></Reveal>
        </div>
      </section>

      <section className="pb-28 pt-4 px-6">
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <Reveal><p className="italic text-[var(--ink-muted)]">Foundation programming and giving initiatives will be announced as they are established.</p></Reveal>
          <Reveal delay={0.08}>
            <Link to="/contact" data-testid="foundation-contact" className="inline-block px-9 py-3.5 bg-[var(--ink)] text-[var(--stone)] font-display uppercase tracking-wide2 text-xs border border-[var(--ink)] hover:bg-transparent hover:text-[var(--ink)] transition-colors">
              Contact the Foundation
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
